export const QUESTIONS_ROUTES = {
  Q_AND_A: 'questions-and-answers',
  FAQ: 'frequently-asked-questions',
  Q_AND_A_SETTINGS: 'questions-and-answers-settings',
};
